import { render } from "./ListeAgentConsignatairePage.vue?vue&type=template&id=5c99ab08&ts=true"
import script from "./ListeAgentConsignatairePage.vue?vue&type=script&lang=ts"
export * from "./ListeAgentConsignatairePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__